/* unplugin-vue-components disabled */import { render } from "./exam-Vocabulary.vue?vue&type=template&id=e4cf7864&scoped=true"
import script from "./exam-Vocabulary.vue?vue&type=script&lang=js"
export * from "./exam-Vocabulary.vue?vue&type=script&lang=js"

import "./exam-Vocabulary.vue?vue&type=style&index=0&id=e4cf7864&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4cf7864"]])

export default __exports__